import { getUserAttemptsForToday, getUserPaymentStatus } from "../endpoints/api"

const usePricing = () => {

    const fetchUserAttempts = async (uuid: string) => {
        try {
            const userAttemptsResp = await getUserAttemptsForToday(uuid)
            // console.log("User attempts resp", userAttemptsResp)
            if (userAttemptsResp && userAttemptsResp.data !== null) {
                return userAttemptsResp.data
            } else {
                return null
            }
        } catch (error) {
            console.log("Error in fetching user attempts", error)
            return null
        }
    }

    const fetchUserPaymentStatus = async (uuid: string) => {
        try {
            const userPaymentResp = await getUserPaymentStatus(uuid)
            if (userPaymentResp && userPaymentResp.data) {
                return userPaymentResp.data
            }
            return null
        } catch (error) {
            console.log("Error in fetching user subscription status", error)
            return null
        }
    }

    return {
        fetchUserAttempts,
        fetchUserPaymentStatus
    }
};

export default usePricing;
